import RecruiterClient from 'clients/recruiter_client'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import PubSub from 'pubsub-js'
import React, { Component } from 'react'
import styles from './introducer_selector.module.scss'

export default class IntroducerSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      companyToken: props.company_token,
      groupToken: props.group_token,
      introducers: [],
      keyword: props.keyword,
      offerToken: props.offer_token,
      selectable: props.selectable
    }
  }

  componentDidMount() {
    PubSub.subscribe(IntroducerSelector.TOPIC_HIDE, () => this.hideSubscriber())
    this.setListPosition()
  }

  componentDidUpdate(_prevProps, prevState) {
    const { keyword } = this.state

    if (!isEmpty(keyword) && prevState.keyword !== keyword) {
      this.getIntroducers()
    }
  }

  componentWillUnmount() {
    PubSub.unsubscribe(() => this.hideSubscriber())
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { introducers, keyword, selectable } = prevState

    if (selectable && keyword !== nextProps.keyword) {
      return {
        ...prevState,
        introducers: isEmpty(nextProps.keyword) ? [] : introducers,
        keyword: nextProps.keyword
      }
    }

    return prevState
  }

  getIntroducers() {
    const { companyToken, groupToken, offerToken, keyword, selectable } = this.state

    if (!selectable) {
      return null
    }

    return RecruiterClient.searchIntroducers(keyword, companyToken, offerToken, groupToken).then(introducers => {
      this.setState(
        {
          introducers
        },
        () => {
          this.setListPosition()
        }
      )
    })
  }

  setListPosition() {
    this.list.style.width = `${this.list.parentNode.offsetWidth}px`
  }

  hideSubscriber() {
    this.setState({
      introducers: []
    })
  }

  render() {
    const { onSelectIntroducer } = this.props
    const { introducers, keyword } = this.state
    const introducerListItems =
      isEmpty(introducers) && isEmpty(keyword)
        ? null
        : introducers.map(introducer => (
            <div
              className={styles.selectorItem}
              key={introducer.id}
              onClick={() => onSelectIntroducer(introducer)}
              role="presentation"
            >
              <span className={styles.introducerName}>{introducer.name}</span>
              <span className={styles.introducerGroup}>{introducer.group.name}</span>
            </div>
          ))

    return (
      <div
        className={styles.selector}
        ref={ref => {
          this.list = ref
        }}
      >
        {introducerListItems}
      </div>
    )
  }
}

IntroducerSelector.propTypes = {
  company_token: PropTypes.string.isRequired,
  group_token: PropTypes.string.isRequired,
  keyword: PropTypes.string,
  offer_token: PropTypes.string.isRequired,
  selectable: PropTypes.bool.isRequired,
  onSelectIntroducer: PropTypes.func.isRequired
}

IntroducerSelector.defaultProps = {
  keyword: null
}

IntroducerSelector.TOPIC_HIDE = 'IntroducerSelector.HIDE'
IntroducerSelector.TOPIC_SELECT_INTRODUCER = 'IntroducerSelector.SELECT_INTRODUCER'
IntroducerSelector.TOPIC_DESELECT_INTRODUCER = 'IntroducerSelector.DESELECT_INTRODUCER'
